"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPlanExtraData = void 0;
const BaseUserOnboardingExtraData_1 = require("../../../common/domain/BaseUserOnboardingExtraData");
const HlOnboardingDataTypeId_1 = require("../HlOnboardingDataTypeId");
const validator_1 = require("@leavy/validator");
const PaymentPlan_1 = require("./PaymentPlan");
class PaymentPlanExtraData extends BaseUserOnboardingExtraData_1.BaseUserOnboardingExtraData {
    constructor() {
        super(...arguments);
        this.dataTypeId = HlOnboardingDataTypeId_1.HlOnboardingDataTypeId.HL_PAYMENT_PLAN;
    }
    getValueConstructor() {
        return PaymentPlan_1.PaymentPlan;
    }
}
__decorate([
    (0, validator_1.Type)(() => PaymentPlan_1.PaymentPlan),
    __metadata("design:type", PaymentPlan_1.PaymentPlan)
], PaymentPlanExtraData.prototype, "value", void 0);
exports.PaymentPlanExtraData = PaymentPlanExtraData;
//# sourceMappingURL=PaymentPlanExtraData.js.map